import script from "./ViewBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBooking.vue?vue&type=script&setup=true&lang=js"

import "./ViewBooking.vue?vue&type=style&index=0&id=c043e8ec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c043e8ec"]])

export default __exports__